import React from 'react';

import ChallengesLogo from '../../../assets/image/challenges-logo.svg';

import classes from './ChallengeHeaderLogo.module.scss';
import { InBodyHeaderLogo } from '../InBodyHeaderLogo/InBodyHeaderLogo';

const ChallengeHeaderLogo = () => {
  return (
    <InBodyHeaderLogo>
      <img className={classes.logo} src={ChallengesLogo} alt="challenges" />
    </InBodyHeaderLogo>
  );
};

export { ChallengeHeaderLogo };
